import React from "react";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import { navigate } from "../../store/navigation/operations";
import { Button } from "@blueprintjs/core";
import { fetchSuggestionsInCollection } from "../../store/circle_suggestion/operations";
import { selectCollection } from "../../store/home_ui/creators";
import {
  getCircleSuggestionsForSelectedCollection,
  loadingMoreSuggestionsForSelectedCollection,
  loadingInitialSuggestionsForSelectedCollection,
  getNextOffsetInCollection,
  hasMoreInSelectedCollection
} from "../../store/circle_suggestion/selectors";
import SuggestionListCard from "../../components/SuggestionListCard";
import LoadingIndicator from "../../components/LoadingIndicator";
import { convertNameToUrl } from "../../utils/utils";
import { removeProduct } from "../../store/b2b_button/creators";
import SuggestionCard from "../../components/SuggestionCard";

class SuggestionsList extends React.Component {

  componentDidMount() {
    this.props.selectCollection(this.props.collection);
    this.props.fetchSuggestionsInCollection(this.props.collection, 5, 0);
  }

  loadMore = () => {
    this.props.fetchSuggestionsInCollection(this.props.collection, 5, this.props.nextCirclesOffset);
  };

  handleSuggestionClick = suggestion => {
    this.props.navigate(`/suggestion/${this.props.collection}/${convertNameToUrl(suggestion)}/${suggestion.id}`);
    this.props.removeProduct()
  };

  render() {
    const no_circles = this.props.circles.length === 0 && !this.props.loadingInitialCircles;
    return (
      <section className="collection-suggested">
        <div className="main-container">
          <div className="content-wrapper">
            {!no_circles && (
              <div>
                <h1 className="bp3-heading">
                  <Translate value="collection_page.heading" />
                </h1>
                <p>
                  <Translate value="collection_page.subheading" />
                </p>
              </div>
            )}

            {this.props.loadingInitialCircles && <LoadingIndicator />}
            <div className="blocked-card-list">
              {this.props.circles.map((suggestion, idx) => {
                if(this.props.simpleCard){
                  return <SuggestionCard 
                      key={suggestion.id}
                      suggestion={suggestion}
                      onClick={() => {
                        this.handleSuggestionClick(suggestion);
                      }}
                  />
                }else{
                  return <SuggestionListCard
                    key={suggestion.id}
                    suggestion={suggestion}
                    onClick={() => {
                      this.handleSuggestionClick(suggestion);
                    }}
                  />
                }                
              })}
            </div>
            {this.props.hasMoreCircles && (
              <Button intent="primary" className="cta" onClick={this.loadMore}>
                {this.props.loadingMoreCircles && <LoadingIndicator />}
                <Translate value="general_messages.load_more" />
              </Button>
            )}
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  circles: getCircleSuggestionsForSelectedCollection(state),
  loadingInitialCircles: loadingInitialSuggestionsForSelectedCollection(state),
  loadingMoreCircles: loadingMoreSuggestionsForSelectedCollection(state),
  hasMoreCircles: hasMoreInSelectedCollection(state),
  nextCirclesOffset: getNextOffsetInCollection(state)
});

const mapDispatchToProps={
  removeProduct,
  selectCollection,
  navigate,
  fetchSuggestionsInCollection
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuggestionsList);
